import React, { useEffect, useRef } from "react";
import { IonCol } from "@ionic/react";
import CellEdit from "./CellEdit";
import CellCard from "./CellCard";
import ClickAnalyzer from "../ClickAnalyzer";
import CardZero from "../CardZero";
import { _dict } from "../constants";
import { useGlobalStore } from "../stateManagement/globalZustand";
import { GridCellProps } from "../../foo/grid";
import { useUIStore } from "../stateManagement/UIZustand";

export interface CellProps extends GridCellProps {
  updateCell: (index: number, cellProps: Partial<CellProps>) => void;
  handleCustomClickEvent: (index: number, eventType: 'single' | 'double' | 'long' | 'context') => void;
}

const Cell: React.FC<CellProps> = React.memo((props) => {
  const { lang } = useGlobalStore();
  const { selectedLabels, setSelectedLabels } = useUIStore();
  const parentRef = useRef<HTMLDivElement>(null);

  /*useEffect(() => {
    // Update selectedLabels ({[key: string] : number[]}) if not already selected
    if (props.isSelected) {
      // Check if the label is already selected
      if(selectedLabels[props.label] === undefined) {
        setSelectedLabels({ ...selectedLabels, [props.label]: [props.index] });
      }else{
        // If the label is already selected, add the index to the array
        setSelectedLabels({ ...selectedLabels, [props.label]: [...selectedLabels[props.label], props.index] });
      }
    } 
  }, [props.isSelected]);*/

  return (
    <div ref={parentRef}>
      <ClickAnalyzer
        targetRef={parentRef}
        onCustomClickEvent={(eventType) => props.handleCustomClickEvent(props.index, eventType)}
      />
      {props.isEditing ? (
        <CellEdit
          index={props.index}
          updateCell={props.updateCell}
          initialValue={props.isEditing && props.isCard ? props.label ?? "" : ""}
        />
      ) : props.isCard ? (
        <CellCard
          {...props}
          key={props.index+props.label}
        />
      ) : props.isEmpty ? (
        <CardZero
          label={_dict.clickHereToAddACard[lang]}
          image={""}
          icons={[]}
          isBorderBlack={!props.isSelected}
          spinnerIfNoImage={false}
          isBorderHighlighted={props.isSelected}
        />
      ) : null}
    </div>
  );
});

export default Cell;
